module.exports = __webpack_public_path__ + "Roboto-Light-webfont.3581138bd3477ae13eca.svg";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/roboto_light_macroman/Roboto-Light-webfont.svg
// module chunks = 1